<script setup lang="ts">
import { computed } from 'vue'
import type { ScenarioChatForm_Message_BasicSelectionItem } from '../types'
import { Position, Handle } from '@vue-flow/core'
import {
  HoverCardPortal,
  HoverCardRoot,
  HoverCardTrigger,
  HoverCardContent,
} from 'radix-vue'

const props = defineProps<{
  messageClientOnlyId: string
  selectionItem: ScenarioChatForm_Message_BasicSelectionItem
}>()

const emits = defineEmits<{
  (
    e: 'addNextMessage',
    messageClientOnlyId: string,
    selectionClientOnlyId: string
  ): void
}>()

const hasConnection = computed(() => {
  return props.selectionItem.nextScenarioChatMessageClientOnlyId != undefined
})

const handleClick = () => {
  if (!hasConnection.value) {
    emits(
      'addNextMessage',
      props.messageClientOnlyId,
      props.selectionItem.clientOnlyId
    )
  }
}
</script>

<template>
  <HoverCardRoot :open-delay="0" :close-delay="0">
    <HoverCardTrigger as-child>
      <Handle
        :id="selectionItem.clientOnlyId"
        type="source"
        :position="Position.Right"
        :connectable="!hasConnection"
        :class="{
          [$style.sourceHandle]: true,
          [$style.hasConnection]: hasConnection,
          [$style.hasNoConnection]: !hasConnection,
        }"
        @click.stop="handleClick"
      />
    </HoverCardTrigger>
    <HoverCardPortal>
      <HoverCardContent side="right" :side-offset="6" as-child>
        <p v-if="!hasConnection" :class="$style.sourceHandleHoverGuide">
          クリックすると<br />新しいメッセージが追加されます
        </p>
      </HoverCardContent>
    </HoverCardPortal>
  </HoverCardRoot>
</template>

<style lang="scss" module>
.sourceHandle {
  cursor: pointer;

  /* stylelint-disable-next-line */
  &:global(.vue-flow__handle) {
    width: 8px;
    height: 24px;
    border-radius: 4px;
  }
}

.hasConnection {
  background-color: $color-okaneko-blue;
}

.hasNoConnection {
  background-color: $color-gray-500;
}

.sourceHandleButton {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.sourceHandleHoverGuide {
  font-size: 14px;
  background-color: $color-surface-primary;
  padding: 8px;
  border-radius: 4px;
  box-shadow: $shadow-4;
}
</style>
